import { ONLYOFFICE_UI_THEME } from '../../constants';

/** localStorage-Key — pro Browser, nicht mandantengebunden. */
export const PORTAL_ONLYOFFICE_THEME_STORAGE_KEY = 'portalOnlyOfficeTheme:v1';

export type PortalOnlyOfficeTheme = 'dark' | 'light';

const VALID: PortalOnlyOfficeTheme[] = ['dark', 'light'];

/** OnlyOffice DocsAPI `customization.uiTheme` für Hell (Word-Original / DS-Standard). */
export const PORTAL_ONLYOFFICE_LIGHT_UI_THEME = 'theme-light';

export function readPortalOnlyOfficeTheme(): PortalOnlyOfficeTheme {
  if (typeof window === 'undefined') return 'dark';
  try {
    const raw = localStorage.getItem(PORTAL_ONLYOFFICE_THEME_STORAGE_KEY);
    if (raw && (VALID as string[]).includes(raw)) return raw as PortalOnlyOfficeTheme;
  } catch {
    /* localStorage blockiert */
  }
  return 'dark';
}

export function writePortalOnlyOfficeTheme(theme: PortalOnlyOfficeTheme): void {
  try {
    localStorage.setItem(PORTAL_ONLYOFFICE_THEME_STORAGE_KEY, theme);
  } catch {
    /* localStorage voll oder blockiert */
  }
}

/** DocsAPI `uiTheme`: Dunkel = ARKORBIT-Cursor-Theme auf dem DS; Hell = OnlyOffice-Standard. */
export function resolveOnlyofficeUiTheme(theme: PortalOnlyOfficeTheme): string {
  return theme === 'light' ? PORTAL_ONLYOFFICE_LIGHT_UI_THEME : ONLYOFFICE_UI_THEME;
}
